import React, { useState } from "react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger, DialogFooter } from "@/components/ui/dialog";
import { UploadSimple } from "@phosphor-icons/react";
import api from "@/lib/api";
import { toast } from "sonner";

const PROTOCOLS = ["LoRaWAN", "NB_IoT", "WM_Bus", "Modbus"];

export default function TelemetryIngest({ utenze, onIngested }) {
  const [open, setOpen] = useState(false);
  const [meterId, setMeterId] = useState("");
  const [flow, setFlow] = useState("");
  const [protocol, setProtocol] = useState("LoRaWAN");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!meterId || !flow) return;
    setLoading(true);
    try {
      const { data } = await api.post("/v1/meter-telemetry", {
        meter_id: meterId, flow_lh: parseFloat(flow), protocol,
      });
      toast.success(`Telemetria ingerita · ${data.ml_samples} campioni ML`);
      setOpen(false); setFlow(""); setMeterId("");
      onIngested?.();
    } catch (e) {
      toast.error(e.response?.data?.detail || "Errore ingestione");
    } finally { setLoading(false); }
  };

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        <Button variant="outline" size="sm" className="border-slate-700 hover:bg-slate-800 gap-2" data-testid="ingest-open-button">
          <UploadSimple weight="bold" size={16} /> Ingerisci Telemetria
        </Button>
      </DialogTrigger>
      <DialogContent className="bg-[#111827] border-slate-800 text-slate-100" data-testid="ingest-dialog">
        <DialogHeader><DialogTitle className="font-heading">Ingestione IoT Smart Meter</DialogTitle></DialogHeader>
        <form onSubmit={submit} className="space-y-4">
          <div>
            <Label className="text-xs uppercase tracking-wider text-slate-400">Meter ID</Label>
            <Select value={meterId} onValueChange={setMeterId}>
              <SelectTrigger className="mt-2 bg-[#0a0f1c] border-slate-800 font-mono" data-testid="ingest-meter-select">
                <SelectValue placeholder="Seleziona contatore" />
              </SelectTrigger>
              <SelectContent className="bg-[#111827] border-slate-800">
                {utenze.map((u) => (
                  <SelectItem key={u.id} value={u.id} className="font-mono text-xs">{u.id} · {u.indirizzo}</SelectItem>
                ))}
              </SelectContent>
            </Select>
          </div>
          <div>
            <Label className="text-xs uppercase tracking-wider text-slate-400">Flusso istantaneo (L/h)</Label>
            <Input type="number" step="0.1" required value={flow} onChange={(e)=>setFlow(e.target.value)}
              className="mt-2 bg-[#0a0f1c] border-slate-800 font-mono" data-testid="ingest-flow-input" />
          </div>
          <div>
            <Label className="text-xs uppercase tracking-wider text-slate-400">Protocollo</Label>
            <Select value={protocol} onValueChange={setProtocol}>
              <SelectTrigger className="mt-2 bg-[#0a0f1c] border-slate-800 font-mono" data-testid="ingest-protocol-select">
                <SelectValue />
              </SelectTrigger>
              <SelectContent className="bg-[#111827] border-slate-800">
                {PROTOCOLS.map((p) => <SelectItem key={p} value={p} className="font-mono text-xs">{p}</SelectItem>)}
              </SelectContent>
            </Select>
          </div>
          <DialogFooter>
            <Button type="submit" disabled={loading} className="bg-[#3EB6F0] text-[#070B14] hover:bg-[#2CA4DE]" data-testid="ingest-submit-button">
              {loading ? "Invio..." : "Invia telemetria"}
            </Button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
}
